/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoRosreestrIcon16Solid = forwardRef('GovKoRosreestrIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 5V.022A5.502 5.502 0 0 0 3.022 5H8Z" }),
        React.createElement("path", { d: "M9 5V.022A5.502 5.502 0 0 1 13.978 5H9Z" }),
        React.createElement("path", { d: "M9 6h4.978A5.502 5.502 0 0 1 9 10.978V6Z" }),
        React.createElement("path", { d: "M7.968 12H3v3.545c0 .252.204.455.455.455a4.546 4.546 0 0 0 4.513-4Z" }),
        React.createElement("path", { d: "M8 11H3V6h5v5Z" })));
});
